import {Injectable} from '@angular/core';
import {count, Observable, ReplaySubject} from 'rxjs';
import {countries, Country} from '../models/countries.model';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private defaultGermany = ['DE'];
  private defaultEUList = ['DE','AT','FR','ES','GB', 'CH','IT'];
  private _countries$ = new ReplaySubject<Country[]>(1);
  public countries$: Observable<Country[]> = this._countries$.asObservable();
  private readonly fullCountryList = countries;
  private availableCountries : Country[] = [];
  private _preSelectedCountry$ = new ReplaySubject<Country>(1);
  public preSelectedCountry$ = this._preSelectedCountry$.asObservable();
  
  
  constructor() {
    this.availableCountries = this.fullCountryList
        .filter((c) => this.defaultGermany.includes(c.countryCode2));
    this._countries$.next(JSON.parse(JSON.stringify(this.availableCountries)) );
    const country = countries.find(c => c.countryCode2 === 'DE');
    if(!!country) {
      this._preSelectedCountry$.next(country);
    }
  }
  
  public setCountries(specialCountries: string | undefined, removeEU: boolean): void {
    let addedEU, addedSpecials = false;
    if(!removeEU) {
      addedEU = true;
      this.availableCountries = this.fullCountryList.filter((c) =>
          this.defaultEUList.includes(c.countryCode2));
    }
    if(!!specialCountries) {
      const list = specialCountries?.split(',');
      if (!!list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          const country = this.fullCountryList.find(c => c.countryCode2 === list[i].toUpperCase().trim());
          if (!!country) {
            this.availableCountries.push(country);
            addedSpecials = true;
          }
        }
        if (addedSpecials) {
          this.availableCountries = [...new Set(this.availableCountries)];
        }
      }
    }
    
    if (addedEU || addedSpecials) {
      const countries: Country[] = JSON.parse(JSON.stringify(this.availableCountries));
      const country = countries.find(c => c.countryCode2 === 'DE');
      this._countries$.next(countries);
      this._preSelectedCountry$.next(!!country ? country : countries[0]);
    }
  }
}
